import { SupportItem } from '../pages/CatalogSupport/hooks';

export const notification = 'notification';
export const contentpages = 'content-page';


export const supportButtonData: SupportItem[] = [
  {
    title: 'Dh Dock',
    icon: 'docs',

    links: [
      {
        title: 'Docspace',
        url: 'https://docspace.lhsystems.com/display/DHLHG/Digital+Hangar+Dock',
      },
    ] as any,
  },
  {
    title: 'Support',
    icon: 'description',

    links: [
      {
        title: 'Product Catalog Support',
        url: 'https://forms.office.com/e/HnYfZ56u2j?origin=lprLink',
      },
    ] as any,
  },
  {
    title: 'Community support',
    icon: 'chat',

    links: [
      {
        title: 'Teams Channel',
        url: 'https://teams.microsoft.com/l/channel/19%3a27b204337dec4722933042df9b6d3ce5%40thread.tacv2/Chapter%2520DevOps?groupId=600f824f-943a-43e9-b56f-f304606d96c8&tenantId=72e15514-5be9-46a8-8b0b-af9b1b77b3b8',
      },
    ] as any,
  },
];
